/**
 * View component for /admin/authoring/courses/new
 *
 * Creates a new course from a copy of the defaultItem in the course reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as courseActions from '../courseActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import TrainingManagementLayout from '../../admin/components/TrainingManagementLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import course components
import CourseForm from '../components/CourseForm.js.jsx';

class AdminCreateCourseFromStudy extends Base {
  constructor(props) {
    super(props);
    this.state = {
      course: _.cloneDeep(this.props.defaultCourse)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {
        isNewOverviewContent: true
        , statuses: ['published', 'draft', 'archived']
        , ordered: 'no'
      }

    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sponsorActions.fetchListIfNeeded("all"));
    dispatch(contentModuleActions.fetchListIfNeeded("_organization", null, "_group", null));
    dispatch(contentModuleActions.fetchListIfNeeded("_group", match.params.studyId));
    dispatch(studyActions.fetchSingleIfNeeded(match.params.studyId)).then((studyAction) => {
      if(studyAction.success) {
        dispatch(studyActions.fetchListIfNeeded("_organization", studyAction.item._organization));
        dispatch(contentModuleActions.fetchListIfNeeded("_organization", studyAction.item._organization, "_group", null));
        dispatch(sponsorActions.fetchSingleIfNeeded(studyAction.item._organization));
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    let newCourse = _.cloneDeep(this.state.course);
    if(nextProps.sponsorStore.selected && nextProps.sponsorStore.selected.id) {
      newCourse._organization = nextProps.sponsorStore.selected.id;
    }
    if(nextProps.studyStore.selected && nextProps.studyStore.selected.id) {
      newCourse._group = nextProps.studyStore.selected.id;
    }
    this.setState({course: newCourse});
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    // NOTE: only do this on the create form
    if(e.target.name === "course.title") {
      newState.course.slug = _.kebabCase(e.target.value);
    }
    this.setState(newState);
  }


  _handleFormSubmit(e) {
    const { dispatch, history, match } = this.props;
    e.preventDefault();

    const { formHelpers } = this.state;
    let newCourse = _.cloneDeep(this.state.course);
    newCourse.ordered = (formHelpers.ordered == 'yes')

    dispatch(courseActions.sendCreateCourse(newCourse)).then((action) => {
      if(action.success) {
        dispatch(courseActions.invalidateList());
        history.push(`${match.url.replace('new', action.item._id)}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const { course, formHelpers } = this.state;
    const {
      courseStatuses
      , location
      , match
      , sponsorStore
      , studyStore
      , contentModuleStore
    } = this.props;
    const isEmpty = (course.title === null || course.title === undefined);
    const selectedStudy = studyStore.selected.getItem(); 
    const allSponsors = sponsorStore.util.getList() || [];
    const allStudies = studyStore.util.getList("_organization", course._organization) || [];
    let contentModules = [];
    // get all needed content modules
    const universalContentModules = contentModuleStore.util.getList("_organization", null, "_group", null) || [];
    const sponsorContentModules = contentModuleStore.util.getList("_organization", course._organization, "_group", null) || [];
    const studyContentModules = contentModuleStore.util.getList("_group", course._group) || [];
    // combine all arrays & drop duplicates
    contentModules = _.unionBy(universalContentModules, sponsorContentModules, studyContentModules, "_id");
    return (
      <TrainingManagementLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            { isEmpty ?
              <h2> Loading...</h2>
              : selectedStudy && selectedStudy.memberContent && selectedStudy.memberContent.hasAccess ?
                <CourseForm
                  allSponsors={allSponsors}
                  allStudies={allStudies}
                  cancelLink={`${match.url.replace('/courses/new', '')}`}
                  course={course}
                  formHelpers={formHelpers}
                  formTitle="Create new course from study"
                  formType="create"
                  fromStudy={true}
                  handleFormChange={this._handleFormChange}
                  handleFormSubmit={this._handleFormSubmit}
                  contentModules={contentModules}
                />
              : 
              <div className="yt-container">
                <h2>Program does not have access to create course </h2>
                <Link to={`${match.url.replace('/courses/new', '')}`}>Go back</Link>
              </div>
            }
          </section>
        </div>
      </TrainingManagementLayout>
    )
  }
}

AdminCreateCourseFromStudy.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultCourse: store.course.defaultItem
    , sponsorStore: store.sponsor
    , studyStore: store.study
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCreateCourseFromStudy)
);



// WEBPACK FOOTER //
// modules/course/views/AdminCreateCourseFromStudy.js.jsx